export default __webpack_public_path__ + "static/media/fad-hardclipcurve.22ce4dcc.svg";